
export const CoverData = [
  {
    page:'WEB&UI DESIGN',
    cover: '/Web&UI/cover.png',
    chineseText: '零',
    miniCover: '/Web&UI/cover_mini.png',
  },
  {
    page:'GRAPHICS',
    cover: '/Graphics/cover.png',
    chineseText: '壹',
    miniCover: '/Graphics/cover_mini.png',
  },
  {
    page: 'MODELINGS',
    cover: '/Modelings/cover.png',
    chineseText: '贰',
    miniCover: '/Modelings/cover_mini.png',
  },
];

//mini指的是 192分辨率下 450长 200宽的小图片
export const GraphicsData = [
  {
    type: 'photo',
    photoId: '/Graphics/0.png',
    imageScale: '0.6',
  },
  {
    type: 'text',
    width: '600',
    text: `
I'm on a relentless quest for mind-bending visual experiences, where I sculpt entire worldviews with vivid, high-impact colors and elements. My design ethos is an unapologetic rebellion against the ordinary in graphic design. I boldly tread into uncharted territories of color, firmly convinced of their ability to awaken emotions, transmit messages, and forge unforgettable visual odysseys.
        `,
  },
  {
    type: 'photo',
    width: '500',
    photoId: '/Graphics/1.png',
    imageScale: '1.1',
  },
  {
    type: 'photo',
    width: '500',
    photoId: '/Graphics/2.png',
    imageScale: '1.1',
  },
  {
    type: 'photo',
    photoId: '/Graphics/3.png',
    imageScale: '0.8',
  },
  {
    type: 'photo',
    photoId: '/Graphics/4.png',
    imageScale: '0.8',
  },
  {
    type: 'photo',
    photoId: '/Graphics/5.png',
    // imageScale: '0.8',
  },
  {
    type: 'photo',
    photoId: '/Graphics/6.png',
    width: '1200',
    // imageScale: '0.8',
  },
  {
    type: 'photo',
    photoId: '/Graphics/7.png',
    width: '1200',
    // imageScale: '0.8',
  },
  {
    type: 'photo',
    photoId: '/Graphics/8.1.png',
    width: '1200',
    // imageScale: '0.8',
  },
  {
    type: 'photo',
    photoId: '/Graphics/8.2.png',
    width: '1200',
    // imageScale: '0.8',
  },
  {
    type: 'photo',
    photoId: '/Graphics/8.3.png',
    width: '1200',
    // imageScale: '0.8',
  },
  {
    type: 'photo',
    photoId: '/Graphics/8.4.png',
    width: '1200',
    // imageScale: '0.8',
  },
  {
    type: 'photo',
    photoId: '/Graphics/9.png',
    width: '1200',
    // imageScale: '0.8',
  },
  {
    type: 'photo',
    photoId: '/Graphics/10.png',
    width: '1200',
    // imageScale: '0.8',
  },
  {
    type: 'photo',
    photoId: '/Graphics/11.png',
    width: '1200',
    // imageScale: '0.8',
  },
];

export const WebUIDesignDate = [
  {
    type: 'photo',
    photoId: '/Web&UI/0.png',
  },
  {
    type: 'text',
    width: '800',
    // title: '西藏游记',
    text: `
        My journey into web design began a decade ago, as I meticulously analyzed outstanding websites to grasp the personality behind them. 
        For me, a website isn't just a static information hub; it's a dynamic avenue for communication.
Inspiration fuels my work, drawn from various sources such as games, art, exhibitions, science fiction, and literature. I explore ways to immerse viewers in the spirit of my clients. 
I also love experimenting with cutting-edge technologies with friends, turning web pages into storytelling canvases.
 <br/>
 <br/>
My passion lies in sparking inspiration and embracing innovation. I'm dedicated to pushing boundaries, incorporating unique elements into my designs, ensuring each project radiates personality and charm.
        `,
  },
  {
    type: 'video',
    width: '1200',
    imageScale: '1',
    photoId: '/Web&UI/1.mp4',
    mask: '20',
    mobileMask: '30',
  },
  {
    type: 'video',
    width: '1200',
    imageScale: '1',
    photoId: '/Web&UI/3.mp4',
    mask: '20', //单位px
    mobileMask: '30',
    // transformY: '20px',
    // 电脑端的花
  },
  {
    type: 'video',
    width: '900',
    mask: '25',
    imageScale: '0.5',
    photoId: '/Web&UI/2.mp4',
    
    mobileMask: '30',
    // transformY: '20px',
    //手机端的花
  },
  
  {
    type: 'video',
    width: '1200',
    imageScale: '1',
    photoId: '/Web&UI/4.mp4',
    mask: '20',
    mobileMask: '30',
  },
  {
    type: 'photo',
    width: '1200',
    imageScale: '1',
    photoId: '/Web&UI/5.png',
  },
  {
    type: 'photo',
    width: '1200',
    imageScale: '1',
    photoId: '/Web&UI/6.png',
  },
  {
    type: 'video',
    width: '1200',
    imageScale: '1',
    photoId: '/Web&UI/7.mp4',
    mask: '20',
    mobileMask: '30',
  },
  {
    type: 'video',
    width: '1200',
    imageScale: '1',
    photoId: '/Web&UI/8.mp4',
    mask: '20',
    mobileMask: '30',
  },
  {
    type: 'video',
    width: '900',
    mask: '25',
    imageScale: '0.5',
    photoId: '/Web&UI/9.mp4',
    mobileMask: '30',
  },
  {
    type: 'video',
    width: '1200',
    imageScale: '1',
    photoId: '/Web&UI/10.mp4',
    mask: '20',
    mobileMask: '30',
  },
];

export const ModelingsDate = [
  {
    type: 'photo',
    photoId: '/Modelings/0.png',
    imageScale: '0.7',
  },

  {
    type: 'text',
    width: '600',
    text: `
With a background in industrial design, I've ridden the rollercoaster of 3D technology's rapid evolution. Exploring diverse rendering techniques has been an electrifying ride.      
<br/>
      <br/>
I'm fueled by the ever-changing tech landscape, driving me to craft innovative, boundary-pushing 3D designs that leave jaws dropping.        `,
  },
  {
    type: 'photo',
    width: '1200',
    photoId: '/Modelings/1.jpg',
    //imageScale: '1',
  },
  {
    type: 'photo',
    width: '1200',
    photoId: '/Modelings/2.jpg',
    //imageScale: '1',
   // describe: 'Game Museum Wall Design, 2.4m x 2.2m, LED and Polyurethane Foam',
  },
  {
    type: 'photo',
    width: '1200',
    photoId: '/Modelings/3.jpg',
    //imageScale: '1',

  },
  // {
  //   type: 'text',
  //   width: '600',
  //   text: `
  //      This is a gate installation design for a game museum, which not only needs to be eye-catching, but also to integrate various game elements. Therefore, based on the client's preferences, I attempted to use LED lights and acrylic materials to suspend the elements and create a realistic game HUD (head-up display) visual effect.
  //
  //       `,
  // },
  {
    type: 'video',
    width: '900',
    //imageScale: '1',
    describe: 'Vtuber character design and modeling, Live2d',
    photoId: '/Modelings/7.mp4',
    mask: '30',
    mobileMask: '30',
  },
  // {
  //   type: 'text',
  //   width: '600',
  //   text: `
  //     By constantly learning the new techniques, I am able to turn my original character drawings into motion capture models and stream them live on various platforms.
  //       `,
  // },
  {
    type: 'photo',
    width: '800',
    photoId: '/Modelings/4.png',
  },
  {
    type: 'photo',
    width: '500',
    //imageScale: '0.6',
    photoId: '/Modelings/5.png',
  },
  {
    type: 'video',
    width: '700',
    imageScale: '1',
    photoId: '/Modelings/6.mp4',
    mask: '30',
    mobileMask: '30',
  }
];
